import { render, staticRenderFns } from "./ExamUser.vue?vue&type=template&id=38542198"
import script from "./ExamUser.vue?vue&type=script&lang=js"
export * from "./ExamUser.vue?vue&type=script&lang=js"
import style0 from "./ExamUser.vue?vue&type=style&index=0&id=38542198&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports